export const CONTROL_VARIANT = Object.freeze({
	WIDE: 'wide',
	CENTERED: 'centered',
})
